import React from 'react'
import SimpleTooltip from 'react-simple-tooltip'
import styled from 'styled-components'

const Content = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 12px;

    width: max-content;
    border-radius: inherit;

    cursor: default;
    font-size: 12px;
    line-height: 22px;
`

const Tooltip = props => {
    const { content, ...rest } = props
    if (!content) return props.children
    return <SimpleTooltip content={<Content>{content}</Content>} {...rest} />
}

Tooltip.defaultProps = {
    arrow: 0,
    padding: 0,
    border: '0',
    radius: 8,
    offset: 8,
    background: 'rgba(0, 0, 8, 0.8)',
}

export default Tooltip
